<template>
    <div class="card-body px-0 pt-0 pb-3">
        <div class="table-responsive">
            <el-table border stripe :data="this.data" class="el-table-css" style="width: 100%">
                <el-table-column label="Status" width="135" align="center">
                    <template #default="{ row }">
                        <span class="status-badge-pill" :class="getStatusBadgeClass(row.statusId)">
                            <i :class="getStatusIcon(row.statusId)"></i>
                            <span>{{ row.quotaStatusName }}</span>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column prop="reqType" label="Sorğu növü" width="240" />
                
                <el-table-column label="Təklif nömrəsi" width="145" align="center">
                    <template #default="scope">
                        <a class="quota-number-pill" @click="GoToQuota(scope.row.quotaId)">
                            <i class="bi bi-file-earmark-text"></i>
                            <span>{{ scope.row.quotaFullNumber }}</span>
                        </a>
                    </template>
                </el-table-column>
                
                <el-table-column prop="quotaDateStr" label="Tarix" width="120" align="center" />
                <el-table-column prop="insured.name" label="Sığortalı" min-width="140" />
                <el-table-column prop="insuredPerson.name" label="Sığortalı olunan" min-width="140" />
                <el-table-column prop="respPerson" label="Məsul şəxs" min-width="130" />
                <el-table-column prop="payType" label="Ödənilmə qaydası" width="150" align="center" />
                
                <el-table-column width="48" align="center">
                    <template #default="scope">
                        <el-popover :width="240" placement="left-start" trigger="hover">
                            <template #reference>
                                <button type="button" class="table-info-trigger" title="Məlumat">
                                    <i class="bi bi-info-circle-fill"></i>
                                </button>
                            </template>
                            <div class="table-info-popover-content">
                                <div class="info-row">
                                    <span class="info-label">Daxil olunub:</span>
                                    <span class="info-val">{{ scope.row.created }}</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">Düzəliş olunub:</span>
                                    <span class="info-val">{{ scope.row.updated }}</span>
                                </div>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Array,
        showFilter: Boolean
    },
    data() {
        return {
            page: 1
        }
    },
    methods: {
        GoToQuota(value) {
            window.open(window.location.origin + '/underwriting/quota/' + value, "_blank");
        },
        getStatusBadgeClass(id) {
            if (id === 2) return 'badge--approved';
            if (id === 1) return 'badge--new';
            if (id === 3) return 'badge--rejected';
            if (id === 4) return 'badge--in-progress';
            return 'badge--default';
        },
        getStatusIcon(id) {
            if (id === 2) return 'bi bi-check-circle-fill';
            if (id === 1) return 'bi bi-sparkles';
            if (id === 3) return 'bi bi-x-circle-fill';
            if (id === 4) return 'bi bi-hourglass-split';
            return 'bi bi-circle-fill';
        }
    }
}
</script>

<style scoped lang="scss">
.status-badge-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 0.76rem;
    font-weight: 650;
    line-height: 1.35;
    letter-spacing: 0.02em;
    width: 100%;
    max-width: 115px;
    border: 1px solid transparent;
    transition: all 0.2s ease;
    user-select: none;

    i {
        font-size: 0.78rem;
    }

    &.badge--approved {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border-color: rgba(16, 185, 129, 0.3);

        i {
            color: #10b981;
        }
    }

    &.badge--new {
        background: rgba(148, 163, 184, 0.12);
        color: #475569;
        border-color: rgba(148, 163, 184, 0.25);

        i {
            color: #64748b;
        }
    }

    &.badge--rejected {
        background: rgba(239, 68, 68, 0.12);
        color: #dc2626;
        border-color: rgba(239, 68, 68, 0.3);

        i {
            color: #ef4444;
        }
    }

    &.badge--in-progress {
        background: rgba(59, 130, 246, 0.12);
        color: #2563eb;
        border-color: rgba(59, 130, 246, 0.3);

        i {
            color: #3b82f6;
        }
    }
}

.quota-number-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 9px;
    border-radius: 6px;
    font-size: 0.82rem;
    font-weight: 700;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    color: var(--bs-info, #0b4f9c);
    background: color-mix(in srgb, var(--bs-info, #0b4f9c) 8%, transparent);
    border: 1px solid color-mix(in srgb, var(--bs-info, #0b4f9c) 20%, transparent);
    cursor: pointer;
    text-decoration: none;
    transition: all 0.18s ease;

    i {
        font-size: 0.8rem;
        opacity: 0.8;
    }

    &:hover {
        background: color-mix(in srgb, var(--bs-info, #0b4f9c) 18%, transparent);
        border-color: var(--bs-info, #0b4f9c);
        color: var(--bs-info, #0b4f9c);
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(11, 79, 156, 0.15);
    }
}

.table-info-trigger {
    border: none;
    background: transparent;
    color: var(--app-text-muted, #94a3b8);
    font-size: 1.05rem;
    cursor: pointer;
    padding: 4px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.18s ease;

    &:hover {
        color: var(--bs-info, #0b4f9c);
        background: var(--app-surface-soft, #f1f5f9);
        transform: scale(1.15);
    }
}

.table-info-popover-content {
    font-size: 0.82rem;
    padding: 4px 2px;

    .info-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        margin-bottom: 6px;

        &:last-child {
            margin-bottom: 0;
        }

        .info-label {
            color: #64748b;
            font-size: 0.78rem;
        }

        .info-val {
            font-weight: 600;
            color: #1e293b;
            font-family: ui-monospace, SFMono-Regular, monospace;
        }
    }
}

[data-theme="dark"] {
    .status-badge-pill {
        &.badge--approved {
            background: rgba(16, 185, 129, 0.16);
            color: #34d399;
            border-color: rgba(52, 211, 153, 0.35);

            i {
                color: #34d399;
            }
        }

        &.badge--new {
            background: rgba(148, 163, 184, 0.14);
            color: #cbd5e1;
            border-color: rgba(148, 163, 184, 0.28);

            i {
                color: #94a3b8;
            }
        }

        &.badge--rejected {
            background: rgba(239, 68, 68, 0.16);
            color: #f87171;
            border-color: rgba(248, 113, 113, 0.35);

            i {
                color: #f87171;
            }
        }

        &.badge--in-progress {
            background: rgba(59, 130, 246, 0.16);
            color: #60a5fa;
            border-color: rgba(96, 165, 250, 0.35);

            i {
                color: #60a5fa;
            }
        }
    }

    .quota-number-pill {
        color: #60a5fa;
        background: rgba(59, 130, 246, 0.12);
        border-color: rgba(96, 165, 250, 0.25);

        &:hover {
            background: rgba(59, 130, 246, 0.22);
            border-color: #60a5fa;
            color: #93c5fd;
            box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25);
        }
    }

    .table-info-trigger:hover {
        color: #60a5fa;
        background: #252f3b;
    }

    .table-info-popover-content .info-row {
        .info-label {
            color: #94a3b8;
        }

        .info-val {
            color: #f1f5f9;
        }
    }
}
</style>